import forEach from "lodash/forEach";
import includes from "lodash/includes";
import indexOf from "lodash/indexOf";
import isEmpty from "lodash/isEmpty";
export function manageOverlay(overlay, manager, show) {
    var _a, _b, _c;
    if (!overlay || !manager || !window)
        return;
    if (show) {
        if (!window[manager])
            window[manager] = [];
        if (!includes(window[manager], overlay))
            (_a = window[manager]) === null || _a === void 0 ? void 0 : _a.push(overlay);
    }
    else if (window[manager] && ((_b = window[manager]) === null || _b === void 0 ? void 0 : _b.length)) {
        const index = indexOf(window[manager], overlay);
        if (index !== -1) {
            (_c = window[manager]) === null || _c === void 0 ? void 0 : _c.splice(index, 1);
        }
        if (isEmpty(window[manager])) {
            delete window[manager];
        }
    }
}
export function hidePopoverOverlays(manager) {
    var _a;
    const lastOpenOverlays = (_a = window[manager]) !== null && _a !== void 0 ? _a : [];
    if (lastOpenOverlays && lastOpenOverlays.length) {
        forEach(lastOpenOverlays, (item) => {
            var _a, _b;
            if ((_a = item === null || item === void 0 ? void 0 : item.instance) === null || _a === void 0 ? void 0 : _a.hide)
                item.instance.hide();
            else if ((_b = item === null || item === void 0 ? void 0 : item.instance) === null || _b === void 0 ? void 0 : _b.close)
                item.instance.close();
        });
    }
}
